import { Fade } from '@mui/material';

export default {
	styleOverrides: {
		list: {
			padding: '8px 4px',
		},
		paper: {
			background: '#FFFFFFB2',
		},
	},
	defaultProps: {
		TransitionComponent: Fade,
		transitionDuration: 300,
	},
};
